import { Link } from "@tanstack/react-router";
import { AppstoreOutlined } from "@ant-design/icons";
import type { NavItemType } from "../../layout/NavItemType.ts";

export const navItem: NavItemType = {
  key: "/raids",
  label: <Link tabIndex={0} to={"/raids"}>Raids</Link>,
  icon: <AppstoreOutlined />,
  order: 2,
};
